<template>
    <div class="content" id="content">

        <toolbar v-bind:selection="toolbar" title="Editar ciclo reina" action="eliminar" />


        <v-text-field
                color="orange"
                label="Nombre de la reina*"
                v-bind:value="detailqueen.name"
                disabled

        ></v-text-field>

        <v-text-field
                color="orange"
                label="Colmenar*"
                v-bind:value="detailqueen.namecolmenar"
                disabled

        ></v-text-field>

        <v-text-field
                color="orange"
                label="Colmena*"
                v-bind:value="detailqueen.number"
                disabled

        ></v-text-field>

        <v-text-field
                color="orange"
                label="Fecha inicio del ciclo*"
                v-bind:value="infoform.date"
                disabled

        ></v-text-field>


        <v-form ref="form" v-model="valid" lazy-validation>

            <!--v-select
                    v-model="infoform.idcolmenar"
                    class="form-group"
                    color="orange"
                    :items="colmenares"
                    item-value="[id]"
                    item-text="[name]"
                    label="Colmenar*"
                    data-vv-name="infoform.idcolmenar"
                    v-on:change="onChange"
                    required
                    :rules="requiredRule"
            ></v-select>

            Solo se muestran las colmenas/núcleo que no tienen reina del colmenar seleccionado.
            <v-select
                    v-model="infoform.idcolmena"
                    class="form-group"
                    color="orange"
                    :items="listColmenas"
                    item-value="[id]"
                    item-text="[number]"
                    label="Colmena/núcleo*"
                    data-vv-name="infoform.idcolmena"
                    required
                    :rules="requiredRule"
            ></v-select>

            <p class="v-messages__message">{{errors.idcolmenar}}</p>

            <p for="date" style="font-size:0.69rem;"><b>Fecha de inicio ciclo*</b></p>
            <datepicker
                    style="margin-bottom:20px;"
                    name="date"
                    id="date"
                    v-model="infoform.date"
                    format="dd/MM/yyyy"
                    class="form-datepicker"></datepicker>
-->
            <v-select
                    v-model="infoform.cycle"
                    class="form-group"
                    color="orange"
                    :items="optionsCycle"
                    label="Ciclo"
                    data-vv-name="infoform.cycle"
            ></v-select>


            <v-select
                    v-model="infoform.state"
                    class="form-group"
                    color="orange"
                    :items="optionsState"
                    label="Estado"
                    data-vv-name="infoform.state"
            ></v-select>

            <loading v-bind:isloading="isloading" ></loading>

            <v-alert
                    dense
                    v-bind:type="alertForm"
                    text
                    :value="alert"
                    transition="scale-transition"
            >
                {{responseform}}
            </v-alert>


            <v-btn :disabled="!valid" class="mr-4 btn-yellow" @click="validate">
                Editar ciclo
            </v-btn>

        </v-form>

    </div>


</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import loading from "@/components/Loader"

import axios from "axios";
import Datepicker from 'vuejs-datepicker';
import {es} from 'vuejs-datepicker/dist/locale'


export default {

    name: 'ciclo-reina-editar',
    components: {
        toolbar,
        loading,
        Datepicker
    },
    data() {
      return {

            toolbar: {
                return: '0',
                icons: [
                  { text: 'Eliminar', click:'delete', id:this.$route.params.id, method:'queens_cycle' },
                  { text: 'Cancelar', href:'ciclo-reina-editar/'+this.$route.params.id}
                ],
            },

            valid: true,

            requiredRule: [
                v => !!v || 'Requerido',
            ],


            isloading:'',

            es: es,

            errors: {
                idcolmenar: '',
                date:'',
            },

            alertForm:'success',
            responseform:'',
            alert: false,


            optionsCycle: [
              { text: 'Operculada', value: 'operculada' },
              { text: 'Eclosión', value: 'eclosion' },
              { text: 'Fecundación', value: 'fecundacion' },
              { text: 'Madura', value: 'madura' },
              { text: 'Vieja', value: 'vieja' },
              { text: 'Muerta', value: 'muerta' }
            ],

            optionsState: [
              { text: 'Introducida', value: 'introducida' },
              { text: 'Aceptada', value: 'aceptada' },
              { text: 'Rechazada', value: 'rechazada' },
              { text: 'Transferida', value: 'transferida' },
              { text: 'Vendida', value: 'vendida' },
              { text: 'Sustituida', value: 'sustituida' },
              { text: 'Enjambrada', value: 'enjambrada' },
              { text: 'Perdida', value: 'perdida' },
              { text: 'Otro', value: 'otro' }
            ],

            listColmenas:[],

            infoform: {
                idcolmenar: '',
                idcolmena: '',
                idqueen: '',
                date: '',
                cycle: '',
                state: '',
            },
            info: null,
            detailqueen: null,
            colmenares: null,
            colmenar:null
  }
  },
  created() {
  auth.getUserLogged()
    this.getTodos();
  },
  methods:{

        async getTodos(){

            var that = this

            await axios.get("https://appws.panimiel.com/new/index.php/api/queens_cycle/detail/"+this.$route.params.id).then((info) => {
              that.info = info.data

                this.infoform.idqueen = that.info.idqueen

                this.infoform.idcolmena = that.info.idcolmena
                this.infoform.idcolmenar = that.info.idcolmenar

                this.infoform.date = that.info.date
                this.infoform.cycle = that.info.cycle
                this.infoform.state = that.info.state
            })

            await axios.get("https://appws.panimiel.com/new/index.php/api/queens/detail/"+this.infoform.idqueen).then((detailqueen) => {
              that.detailqueen = detailqueen.data
            })

            await axios.get("https://appws.panimiel.com/new/index.php/api/colmenar").then((colmenares) => {
              that.colmenares = colmenares.data
            })


            /* LISTADO DE COLMENAS */

            axios.get('https://appws.panimiel.com/new/index.php/api/colmena/no_queen/'+this.infoform.idcolmenar+'/'+this.infoform.idcolmena)
            .then(function (response) {
              that.listColmenas = response.data;
            })

        },

        onChange: function (){
            var self = this
          
           axios.get('https://appws.panimiel.com/new/index.php/api/colmena/no_queen/'+self.infoform.idcolmenar+'/'+self.infoform.idcolmena)
            .then(function (response) {
              self.listColmenas = response.data;

              if(self.listColmenas.length < 1){
               /* self.infoform.idcolmena = ''*/
                self.errors.idcolmenar = "No hay colmenas/núcleos libres para el colmenar seleccionado."
              }else{
                self.errors.idcolmenar = ""
              }
            })
         },


        validate () {
            this.$refs.form.validate()
            if(this.infoform.date===''){
                    this.errors.date = "Debes insertar la fecha de inicio del ciclo."
            }
            if(this.$refs.form.validate()){
                this.errors.date = ''
                this.alert = false
                this.isloading = true

                if(this.infoform.date===''){
                    this.isloading = false
                    this.errors.date = "Debes insertar la fecha de inicio del ciclo."
                }else{

                    this.errors.idcolmenar = ''

                    axios.put('https://appws.panimiel.com/new/index.php/api/queens_cycle/'+this.$route.params.id, this.infoform)
                         .then((response) => {
                         this.responseform = response.data
                         this.alertForm = 'success'
                         this.isloading=''
                         this.alert = true
                    })
                    .catch((error) => {
                        this.alertForm = 'error',
                        this.isloading=''

                        if (error.response.status != 500){
                            this.responseform = error.response.data
                        }else{
                            this.responseform = 'Error, no ha sido posible editar el ciclo de la reina.'
                        }
                         this.alert = true

                     })
                 }
             }
        }
    }


};


</script>

<style scoped lang="scss">
</style>